module.exports = __webpack_public_path__ + "static/media/6464Img.f1a69fda.svg";